module.exports = __webpack_public_path__ + "static/IMC_logo_white_EN-d352401524ff2ce17226f70d2c27a4f4.svg";